import Request from "@/services/request";

import {
  PUBLIC_COOKIE,
  SELLER_DASHBOARD_QUERY_CONFIGS,
  SELLER_STATUS,
  PRODUCT_DEAL_NOTIFICATION,
} from "@/utils/enum/endpoints";

import {
  SET_CONFIG_LIST,
  SET_CHECK_GIB_SELLER_INFO_DATA,
  SET_CHECK_NEED_PASSWORD_CHANGE,
  SET_CUSTOM_DEAL_NOTIFICATION,
} from "./mutation-types";

import {
  NEW_PRODUCT_LIST_DESIGN_ENABLE,
  NEW_PRODUCT_CREATE_DESIGN_ENABLE,
  NEW_BULK_PRODUCT_MANAGEMENT_DESIGN_ENABLE,
  DEAL_LISTING_PAGE_SIZES,
  NEW_PRODUCT_CREATE_SINGLE_SHOW_ENABLE,
  PRODUCT_DETAIL_SHOW_ENABLE,
  CHATBOT_ENABLED,
  CHATBOT_URL,
} from "@/utils/enum/configs";

const request = new Request();

export default {
  async getPublicCookie() {
    await request.post(PUBLIC_COOKIE, {});
  },

  async getConfigList({ commit }) {
    const { data } = await request.get(SELLER_DASHBOARD_QUERY_CONFIGS, {
      configKeys: [
        NEW_PRODUCT_CREATE_DESIGN_ENABLE,
        NEW_PRODUCT_LIST_DESIGN_ENABLE,
        NEW_BULK_PRODUCT_MANAGEMENT_DESIGN_ENABLE,
        DEAL_LISTING_PAGE_SIZES,
        NEW_PRODUCT_CREATE_SINGLE_SHOW_ENABLE,
        PRODUCT_DETAIL_SHOW_ENABLE,
        CHATBOT_ENABLED,
        CHATBOT_URL,
      ],
    });
    commit(SET_CONFIG_LIST, data);
  },

  downloadFile(context, { downloadUrl, fileName }) {
    const link = document.createElement("a");
    const url = downloadUrl;

    Object.assign(link, {
      href: url,
      download: `${fileName}`,
      style: "display: none;",
    });

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  },

  async checkGIBSellerInfo({ commit }) {
    try {
      const res = await request.get(SELLER_STATUS, null);

      commit(SET_CHECK_GIB_SELLER_INFO_DATA, res.data);
      commit(SET_CHECK_NEED_PASSWORD_CHANGE, res.data.needsPasswordChange);
      return res.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async checkCustomDealNotification({ commit }) {
    try {
      const res = await request.get(`${PRODUCT_DEAL_NOTIFICATION}`, null, {
        baseURL: "/sellerofficeapi/rest",
        headers: { Accept: "application/json" },
      });
      commit(SET_CUSTOM_DEAL_NOTIFICATION, res.data);
    } catch {
      commit(SET_CUSTOM_DEAL_NOTIFICATION, false);
    }
  },

  async clearCustomDealNotification({ commit }) {
    try {
      await request.delete(`${PRODUCT_DEAL_NOTIFICATION}`, {}, {
        baseURL: "/sellerofficeapi/rest",
        headers: { Accept: "application/json" },
      });
      commit(SET_CUSTOM_DEAL_NOTIFICATION, false);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
